<!-- #63 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        {{ +$route.params.id === 0 ? "Add" : "Edit" }} SLA Rule
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >{{ +$route.params.id === 0 ? "Add" : "Edit" }}

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <v-form ref="form">
          <v-row class="pb-0">
            <v-col cols="12" sm="3" md="3" class="pb-0">
              <v-text-field
                v-model="slaDetail.sla_name"
                label="SLA Name"
                :rules="[(v) => (v && !!v.trim()) || 'SLA Name is required.']"
                class="required pb-0"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pb-0">
              <v-select
                v-model="slaDetail.carrier_id"
                label="Select Carrier"
                :rules="[(v) => !!v || 'Carriers is required.']"
                class="required pt-0 pb-0"
                item-text="name"
                item-value="id"
                :items="activeCarriersListTypes"
                outlined
                @change="getconfig(slaDetail.carrier_id)"
                @focus="fetchCarriers()"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3" class="pb-0">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(slaDetail.active_from_date)"
                    label="From Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    class="required"
                    outlined
                    :rules="[(v) => !!v || 'From Date is required.']"
                    @click:clear="
                      clearDateInput('this.slaDetail.active_from_date')
                    "
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="slaDetail.active_from_date"
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="3" class="pb-0">
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
                class="custom-text-field"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(slaDetail.active_to_date)"
                    label="To Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    @click:clear="
                      clearDateInput('this.slaDetail.active_to_date')
                    "
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="slaDetail.active_to_date"
                  @input="dateMenuTo = false"
                  :max="getEndDate"
                  :min="new Date().toISOString()"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-divider class="mt-1 mb-4"></v-divider>
            <v-col cols="12" sm="3" class="pb-0 pt-0">
              <v-autocomplete
                v-model="slaDetail.service_level_type"
                :items="service_level_types"
                outlined
                chips
                small-chips
                class="required"
                label="SLA Type"
                :rules="[(v) => (v && !!v.trim()) || 'SLA Type is required.']"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pb-0 pt-0">
              <v-autocomplete
                label="Payment Mode"
                :items="paymentModes"
                v-model="slaDetail.payment_type"
                class="pb-0 required"
                item-value="value"
                item-text="text"
                :rules="[
                  (v) => (v && !!v.trim()) || 'Payment Mode is required.',
                ]"
                outlined
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3" class="pt-0 pb-0">
              <v-autocomplete
                v-model="slaDetail.delivery_type"
                :items="deliveryTypes"
                outlined
                chips
                item-text="text"
                item-value="value"
                small-chips
                label="Delivery Type"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="pb-0 pt-0"
              v-if="slaDetail.delivery_type == 'crossborder'"
            >
              <v-autocomplete
                v-model="slaDetail.service_type"
                :items="servicesTypesCross"
                outlined
                :item-text="
                  (item) => `${item.service_name} - (${item.service_code})`
                "
                item-value="service_code"
                multiple
                small-chips
                label="Service Type"
              ></v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              sm="3"
              class="pb-0 pt-0"
              v-if="slaDetail.delivery_type == 'domestic'"
            >
              <v-autocomplete
                v-model="slaDetail.service_type"
                :items="servicesTypesDom"
                outlined
                :item-text="
                  (item) => `${item.service_name} - (${item.service_code})`
                "
                item-value="service_code"
                multiple
                small-chips
                label="Service Type"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="pb-0 pt-0"
              v-if="slaDetail.delivery_type == 'crossborder'"
            >
              <v-autocomplete
                v-model="slaDetail.duty_handling"
                :items="dutyhandlings"
                outlined
                chips
                multiple
                small-chips
                label="Duty Handling"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pb-0 pt-0">
              <v-autocomplete
                label="Injection Country"
                :items="countries"
                v-model="slaDetail.source_country_ids"
                outlined
                multiple
                item-text="name"
                item-value="id"
                :search-input.sync="searchText"
                @input="onValueChange"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pb-0 pt-0">
              <v-autocomplete
                label="To Country"
                :items="countriesTo"
                v-model="slaDetail.destination_country_ids"
                outlined
                item-text="name"
                item-value="id"
                multiple
                :search-input.sync="searchText"
                @input="onValueChange"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-divider class="mb-4 mt-1"></v-divider>
          <v-row>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="slaDetail.start_event_code"
                :items="from_events"
                outlined
                class="required pb-0"
                chips
                :rules="[(v) => (v && !!v.trim()) || 'From Event is required.']"
                small-chips
                label="From Event"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="slaDetail.end_event_code"
                :items="to_events"
                outlined
                class="required pb-0"
                chips
                small-chips
                :rules="[(v) => (v && !!v.trim()) || 'To Event is required.']"
                label="To Event"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pb-0 mb-0">
              <v-text-field
                v-model="slaDetail.time_in_hrs"
                label="Time In Hrs"
                @input="calculateDeliveredTime()"
                :rules="[
                  (v) =>
                    (v &&
                      !!v.trim() &&
                      /^[0-9]+$/.test(v) &&
                      !/^[a-zA-Z]+$/.test(v)) ||
                    'Time is required. Only numbers are allowed. A-Z, a-z not allowed.',
                ]"
                class="required pb-0"
                outlined
                hide-details
              ></v-text-field>
              <span class="caption">
                eg: Order collected on {{ new Date().getDate() }}th
                {{ new Date().toLocaleString("default", { month: "long" }) }} at
                12 am should be delivered before
                {{ deliveredTime }}
              </span>
            </v-col>

            <v-col
              cols="12"
              sm="3"
              md="3"
              class="pb-0 mb-0"
              v-if="+$route.params.id !== 0"
            >
              <v-switch
                v-model="slaDetail.status"
                :label="slaDetail.status ? 'Active' : 'In-Active'"
              ></v-switch>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="$route.params.id == 0"
          color="primary"
          @click="savesla"
          :loading="saveLoader"
          class="ma-2"
          >Save</v-btn
        >
        <v-btn
          v-if="
            $route.params.id > 0 &&
            checkPermission('app_sla_tracker:sla_carrier_config_update')
          "
          color="primary"
          @click="savesla"
          :loading="saveLoader"
          class="ma-2"
          >Update</v-btn
        >
        <v-btn
          v-if="$route.params.id !== 0"
          class="ml-3"
          color="error"
          @click="$router.push('/sla-configuration')"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["labelTypes"]),
  },
  data: () => ({
    searchText: "",
    service_level_types: [{ text: "Delivery", value: "delivery" }],
    dateMenuTo: false,
    dateMenu: false,
    countries: [],
    selectedCarriedId: null,
    deliveryTypes: [],
    dutyhandlings: [],
    paymentModes: [],
    servicesTypesCross: [],
    servicesTypesDom: [],
    countriesTo: [],
    carriers: [],
    editedIndex: -1,
    search: null,
    dialogConfirm: false,
    loader: false,
    statusLoader: false,
    remvLinehaul: false,
    carrierId: null,
    active: "",
    label_type_id: "",
    service_type: "",
    name: "",
    filtersArr: {},
    carrierForm: false,
    slaDetail: {
      delivery_type: null,
      payment_type: null,
    },
    saveLoader: false,
    addList: {},
    allServiceTypes: [],
    allTrackingServiceModes: [],
    activeCarriersListTypes: [],
    servicesTypes: [],
    statuses: [
      {
        text: "Active",
        value: "true",
      },
      {
        text: "Inactive",
        value: "false",
      },
    ],
    to_events: [],
    from_events: [],
    deliveredTime: "",
  }),

  async created() {
    await this.fetchCarriers();
    await this.fetchEvent();
    await this.getCountries().then((res) => {
      this.countries = res.data;
    });
    if (this.$route.params.id > 0) {
      this.getSlaRecord(this.$route.params.id).then(async (res) => {
        this.getconfig(res.data.records[0].carrier_id_id);

        this.slaDetail = res.data.records[0];
        this.slaDetail.carrier_id = res.data.records[0].carrier_id_id;

        this.slaDetail.duty_handling = res.data.records[0].duty_handling
          ? res.data.records[0].duty_handling
              .split(",")
              .map((item) => item.trim())
          : [];

        this.slaDetail.destination_country_ids = this.slaDetail
          .destination_country_ids
          ? this.slaDetail.destination_country_ids.split(",")
          : [];
        this.slaDetail.source_country_ids = this.slaDetail.source_country_ids
          ? this.slaDetail.source_country_ids.split(",").map(Number)
          : [];
        this.slaDetail.time_in_hrs = this.slaDetail.time_in_hrs.toString();
        this.slaDetail.service_type = this.slaDetail.service_type
          ? this.slaDetail.service_type.split(",").map((code) => code.trim())
          : [];
        this.calculateDeliveredTime();
      });
    }
  },

  methods: {
    ...mapActions([
      "getCountries",
      "snackBar",
      "getLabelTypes",
      "addCarriers",
      "getSlaDetails",
      "getAddCarrier",
      "getCarriersDropdown",
      "getRSAServiceListOnly",
      "summaryEvent",
      "getSlaRecord",
      "addSLA",
      "updateSLA",
      "getCarrierconfig",
    ]),
    onValueChange() {
      this.searchText = ""; // Clear the search input after selection
    },
    getconfig(id) {
      this.dutyhandlings = [];
      this.slaDetail.duty_handling = [];
      this.servicesTypesCross = [];
      this.servicesTypesDom = [];
      this.slaDetail.service_type = [];

      this.deliveryTypes = [];
      this.slaDetail.delivery_type = null;

      this.countriesTo = [];
      this.slaDetail.destination_country_ids = [];
      this.paymentModes = [];
      this.slaDetail.payment_type = "";

      this.getCarrierconfig(id).then((res) => {
        this.paymentModes = res.data.payment_type
          ? res.data.payment_type.split(",")
          : [];
        if (this.paymentModes.length == 2) {
          this.paymentModes.push({
            text: "COD & Prepaid",
            value: "COD,Prepaid",
          });
        }
        this.countriesTo = Object.keys(res.data.to_country).map((key) => ({
          name: res.data.to_country[key],
          id: key,
        }));

        this.servicesTypesCross = res.data.crossborder_services
          ? res.data.crossborder_services
          : [];
        this.deliveryTypes = res.data.delivery_type;
        this.dutyhandlings =
          res.data.carrier_settings && res.data.carrier_settings.duty_handling
            ? res.data.carrier_settings.duty_handling.split(",")
            : [];
        this.servicesTypesDom = res.data.crossborder_services
          ? res.data.domestic_services
          : [];
      });
    },
    calculateDeliveredTime() {
      if (!this.slaDetail.time_in_hrs) return;
      const inputHours = parseInt(this.slaDetail.time_in_hrs, 10);
      if (isNaN(inputHours)) return;

      // Calculate the new delivery date and time based on input hours
      const now = new Date();
      now.setHours(inputHours);

      // Format the time to a readable format
      this.deliveredTime = now.toLocaleString("en-US", {
        hour: "numeric",
        hour12: true,
        day: "numeric",
        month: "long",
      });
    },

    fetchEvent() {
      this.summaryEvent().then((res) => {
        this.from_events = res.data.sla_event_list.from_events;
        this.to_events = res.data.sla_event_list.to_events;
      });
    },
    async fetchCarriers() {
      if (this.activeCarriersListTypes.length) return;
      await this.getCarriersDropdown({
        pagination: 0,
        active: "all",
      })
        .then((res) => {
          this.activeCarriersListTypes = res.data.filter(
            (carrier) => carrier.active === true
          );
        })
        .catch(() => {
          this.loader = false;
        });
    },
    allService() {
      this.allServiceTypes = Object.keys(this.addList.list_service_type).map(
        (i) => {
          return {
            text: this.capitalizeFirstLetter(i),
            value: i,
          };
        }
      );
      this.paymentModes = Object.keys(
        this.addList.list_service_payment_type
      ).map((i) => {
        return {
          text: this.addList.list_service_payment_type[i],
          value: i,
        };
      });
      this.allTrackingServiceModes = Object.keys(
        this.addList.list_tracking_service_mode
      ).map((i) => {
        return {
          text: this.addList.list_tracking_service_mode[i],
          value: i,
        };
      });
    },

    fetchSlaDetails() {
      if (this.$route.params.id > 0) {
        this.loader = true;
        // this.$router.replace(`/carriers/edit/${this.$route.params.id}`);
        this.getSlaDetails(this.$route.params.id)
          .then((res) => {
            this.loader = false;
            this.slaDetail = res.data;
            this.slaDetail.active = res.data.active;
            this.addList = res.data.drop_down_list;
            this.allService();
            this.logoUrl =
              "/images/logo/" + res.data.carrier_logo.split("/").pop();
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },

    clearDateInput(value) {
      if (value == "this.slaDetail.active_to_date") {
        this.slaDetail.active_to_date = null;
      } else {
        this.slaDetail.active_from_date = null;
      }
    },
    savesla() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;
      this.copyArr = JSON.parse(JSON.stringify(this.slaDetail));
      this.slaDetail.destination_country_ids = this.slaDetail
        .destination_country_ids
        ? this.slaDetail.destination_country_ids.join(",")
        : "";
      this.slaDetail.source_country_ids = this.slaDetail.source_country_ids
        ? this.slaDetail.source_country_ids.join(",")
        : "";
      this.slaDetail.duty_handling = this.slaDetail.duty_handling
        ? this.slaDetail.duty_handling.join(",")
        : "";
      this.slaDetail.service_type = this.slaDetail.service_type
        ? this.slaDetail.service_type.join(",")
        : "";
      if (this.$route.params.id == 0) {
        this.addSLA({
          data: this.slaDetail,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.push("/sla-configuration");
          })
          .catch(() => {
            this.saveLoader = false;
            this.slaDetail = this.copyArr;
          });
      } else {
        this.slaDetail.status = this.slaDetail.status ? 1 : 0;
        this.updateSLA({
          id: this.$route.params.id,
          data: this.slaDetail,
        })

          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.push("/sla-configuration");
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },
  },
};
</script>
